import jQuery from 'jquery';
import 'jquery-ui-sortable';

// Sourced from rails_sortable
// https://github.com/itmammoth/rails_sortable/blob/master/vendor/assets/javascripts/plugin.js
(function($) {
  $.fn.railsSortable = function(options) {
    options = options || {};
    var settings = $.extend({}, options);

    settings.update = function(event, ui) {
      if (typeof options.update === 'function') {
        options.update(event, ui);
      }

      $.ajax({
        type: 'POST',
        url: '/sortable/reorder',
        dataType: 'json',
        contentType: 'application/json',
        data: JSON.stringify({
          /* eslint-disable-next-line @typescript-eslint/camelcase */
          rails_sortable: $(this).sortable('toArray'),
        }),
      });
    };

    this.sortable(settings);
  };

  $('.sortable').railsSortable();
})(jQuery);
